import { render, staticRenderFns } from "./MonthItem.vue?vue&type=template&id=2751082b&"
import script from "./MonthItem.vue?vue&type=script&lang=js&"
export * from "./MonthItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports